import { Dropdown, Menu } from "antd";
import { UploadStatus } from "../../shared/constant";
import icons from "../../shared/icons";
import { IKeyValue } from "../../shared/table/types";

const SalesTableActions = (
  onFileDelete: Function,
  onFileProcess: Function,
  onFileMap: Function,
  onFileDownload: Function,
) => {
  const onMapData = (record: IKeyValue) => {
    onFileMap(record);
  };
  const onProcessData = (record: IKeyValue) => {
    onFileProcess(record);
  };
  const onDelete = (record: IKeyValue) => {
    onFileDelete(record);
  };
  const onDownload = (record: IKeyValue) => {
    onFileDownload(record);
  };

  const downloadAction = (record: any) => ({
    label: (
      <div
        onClick={() => onDownload(record)}
        aria-hidden="true"
        className="text-label"
      >
        Download
      </div>
    ),
    key: "DOWNLOAD",
  });

  const deleteAction = (record: any) => ({
    label: (
      <div
        onClick={() => onDelete(record)}
        aria-hidden="true"
        className="text-label"
      >
        Delete
      </div>
    ),
    key: "DELETE",
  });

  return {
    title: "",
    key: "action",
    render: (_: any, record: any) => (
      <div className="text-secondary text-right">
        <Dropdown
          overlay={
            <Menu
              className="min-w-[100px] rounded-[3px]"
              items={(() => {
                switch (record.status) {
                  case UploadStatus.QUEUED:
                    return [
                      {
                        label: (
                          <div
                            onClick={() => onMapData(record)}
                            aria-hidden="true"
                            className="text-label"
                          >
                            Map
                          </div>
                        ),
                        key: "MAP",
                      },
                      downloadAction(record),
                      deleteAction(record),
                    ];
                  case UploadStatus.MAPPED:
                    return [
                      {
                        label: (
                          <div
                            onClick={() => onProcessData(record)}
                            aria-hidden="true"
                            className="text-label"
                          >
                            Process
                          </div>
                        ),
                        key: "PROCESS",
                      },
                      downloadAction(record),
                      deleteAction(record),
                    ];
                  case UploadStatus.MAPPING:
                  case UploadStatus.PROCESSING:
                    return [downloadAction(record)];
                  case UploadStatus.DELETING:
                    return [downloadAction(record)];
                  case UploadStatus.FAILED:
                  case UploadStatus.PROCESSED:
                    return [downloadAction(record), deleteAction(record)];

                  default:
                    return [];
                }
              })()}
            />
          }
          trigger={["click"]}
        >
          <button type="button">{icons.DotsVerticle()}</button>
        </Dropdown>
      </div>
    ),
  };
};

export default SalesTableActions;
